import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule, TooltipModule } from 'ngx-bootstrap';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../../../../shared/shared/shared.module';
import { DestinationInfoComponent } from './destination-info.component';
import { DestinationInfoDestinationEditComponent } from './destination-edit/destination-info-destination-edit.component';
import { DestinationInfoAddImageComponent } from './destination-add-image/destination-info-add-image.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
  ],
  declarations: [
    DestinationInfoComponent,
    DestinationInfoDestinationEditComponent,
    DestinationInfoAddImageComponent,
  ]
})
export class DestinationInfoModule {
}
